import React, { useState } from 'react';
import classNames from 'classnames';
import styles from 'components/common/upload/DocumentUpload.module.scss';

interface DocumentUploadProps {
  title: string;
  children: React.ReactNode;
  onUpload: (file: File) => void;
  onSave: (file: File) => void;
}

export const DocumentUpload = (props: DocumentUploadProps) => {
  const { title, children, onSave } = props;
  const [file, setFile] = useState<File | null>(null);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  const handleSave = () => {
    if (file) {
      return onSave(file);
    }
  };

  return (
    <div className={styles.documentUploadContainer}>
      <div className={styles.documentUploadHeaderContainer}>
        <h2>{title}</h2>
      </div>
      <div className={styles.documentUploadBodyContainer}>{children}</div>
      <div className={styles.documentUploadFooterContainer}>
        <form>
          <input
            type="file"
            accept="text/csv"
            className={styles.documentFile}
            id="input-file"
            onChange={handleInputChange}
          />
          <label htmlFor="input-file" className={styles.documentFileLabel}>
            Browse files to upload
          </label>
          {file && <span>{file?.name}</span>}
        </form>
        <button
          className={classNames(styles.submitButton, {
            [styles.active]: file,
            [styles.disabled]: !file,
          })}
          disabled={!file}
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </div>
  );
};
